export default __webpack_public_path__ + "static/media/nointernetgif.cd75cb0e.gif";